const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="512"
      height="512"
      fill="none"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        fill="#000"
        d="M211.333 56a22.222 22.222 0 00-22.222 22.222h-88.889a22.222 22.222 0 000 44.445v288.889A44.446 44.446 0 00144.667 456h222.222a44.445 44.445 0 0044.444-44.444V122.667a22.225 22.225 0 0015.714-37.936 22.224 22.224 0 00-15.714-6.509h-88.889A22.224 22.224 0 00300.222 56h-88.889zm-22.222 133.333a22.22 22.22 0 0122.222-22.222 22.222 22.222 0 0122.223 22.222v155.556a22.222 22.222 0 01-44.445 0V189.333zm88.889 0a22.22 22.22 0 0122.222-22.222 22.222 22.222 0 0122.222 22.222v155.556a22.221 22.221 0 11-44.444 0V189.333z"
      ></path>
    </svg>
  );
};

export default DeleteIcon;
